/**
 * Converts the hour from 12-hour format to 24-hour format.
 * @param {number | null} hour12 - The hour in 12-hour format (1 to 12) or null if invalid.
 * @param {string} meridiem - The meridiem indicator ("AM" or "PM").
 * @returns {number | null} The hour in 24-hour format (0 to 23) or null if input is invalid.
 */
export function convertTo24Hour(hour12: number, meridiem: 'AM' | 'PM'): number | null {
    // Ensure the input is a valid number between 1 and 12 for hour12 and valid meridiem
    if (hour12 < 1 || hour12 > 12) {
        return null;
    }

    // Convert to 24-hour format
    let hour24 = hour12;
    if (meridiem === 'PM' && hour12 !== 12) {
        hour24 += 12;
    } else if (meridiem === 'AM' && hour12 === 12) {
        hour24 = 0; // 12 AM
    }

    return hour24;
}
